<app-glosario-entidad [mostrarColumnaEditar]="true" [ocultarColumnaEntidad]="false"></app-glosario-entidad>
